import { Check } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconCheck12Line = createIcon(Check, 12, "Line");
export const IconCheck16Line = createIcon(Check, 16, "Line");
export const IconCheck20Line = createIcon(Check, 20, "Line");
export const IconCheck24Line = createIcon(Check, 24, "Line");
export const IconCheck32Line = createIcon(Check, 32, "Line");
export const IconCheck48Line = createIcon(Check, 48, "Line");
export const IconCheck64Line = createIcon(Check, 64, "Line");
